import styled from 'styled-components';

const Container = styled.div`
  display: inline-flex;
  margin-top: 10px;
  margin-left: 2px;
`;

export default Container;
